import { ColorSelect } from "@/dom/components/ColorSelect/ColorSelect";
import { Column } from "@/dom/components/Panel/Column";
import { Row } from "@/dom/components/Panel/Row";
import { Section } from "@/dom/components/Panel/Section";
import { Typography } from "@/dom/components/Typography/Typography";
import { useDemoState } from "@/state/demoState";
import { ROOM_COLOR_SELECTOR_PALETTE } from "@/utils/colors";
import _ from "lodash";
import React, { useMemo } from "react";
import { Color } from "three";

export const RoomStyleSection: React.FC = () => {
    const roomConfig = useDemoState((state) => state.roomConfig);
    const setRoomConfig = useDemoState((state) => state.setRoomConfig);

    const handleFloorColorChange = (color: Color) => {
        setRoomConfig({ ...roomConfig, floorColor: color });
    };

    const handleWallColorChange = (color: Color) => {
        setRoomConfig({
            ...roomConfig,
            leftWall: {
                ...roomConfig.leftWall,
                color,
            },
            rightWall: {
                ...roomConfig.rightWall,
                color,
            },
            frontWall: {
                ...roomConfig.frontWall,
                color,
            },
            backWall: {
                ...roomConfig.backWall,
                color,
            },
        });
    };

    const handleBaseboardColorChange = (color: Color) => {
        setRoomConfig({
            ...roomConfig,
            leftWall: {
                ...roomConfig.leftWall,
                baseboardColor: color,
            },
            rightWall: {
                ...roomConfig.rightWall,
                baseboardColor: color,
            },
            frontWall: {
                ...roomConfig.frontWall,
                baseboardColor: color,
            },
            backWall: {
                ...roomConfig.backWall,
                baseboardColor: color,
            },
        });
    };
    const wallColors = useMemo(() => {
        return (
            _.uniqBy(
                [
                    roomConfig.leftWall.color,
                    roomConfig.rightWall.color,
                    roomConfig.frontWall.color,
                    roomConfig.backWall.color,
                ],
                (color) => color.getHexString()
            ) ?? []
        );
    }, [roomConfig]);

    const baseboardColors = useMemo(() => {
        return _.uniqBy(
            [
                roomConfig.leftWall.baseboardColor,
                roomConfig.rightWall.baseboardColor,
                roomConfig.frontWall.baseboardColor,
                roomConfig.backWall.baseboardColor,
            ],
            (color) => color.getHexString()
        );
    }, [roomConfig]);

    return (
        <Section title="Стиль">
            <Row>
                <span>Пол</span>
                <ColorSelect
                    colors={ROOM_COLOR_SELECTOR_PALETTE}
                    onChange={handleFloorColorChange}
                    selection={[roomConfig.floorColor]}
                />
            </Row>
            <Column noGap>
                <Row>
                    <span>Стены</span>
                    <ColorSelect
                        colors={ROOM_COLOR_SELECTOR_PALETTE}
                        onChange={handleWallColorChange}
                        selection={wallColors}
                    />
                </Row>
                <Row>
                    <span>Плинтуса</span>
                    <ColorSelect
                        colors={ROOM_COLOR_SELECTOR_PALETTE}
                        onChange={handleBaseboardColorChange}
                        selection={baseboardColors}
                    />
                </Row>
                <Typography variant="badge" color="gray1">
                    Выберите стену чтобы изменить цвет
                </Typography>
            </Column>
        </Section>
    );
};
